/**
 * Created by quikr on 8/16/16.
 */

const joinees = {
  joiners: [{
    "candidate_id": "",
    "name": "",
    "location": "",
    "contact": "",
    "DOJ": "",
    "vertical": " ",
    "recruiter": "",
    "designation": " ",
    "offerStatus": "   ",
    "ITStatus": " ",
    "adminStatus": " "
  }]
};
const candidate = {};
export default function recruitReducer(state = [{joinees}, {candidate}], action) {
  switch (action.type) {
    case 'GET_CANDIDATES_SUCCESS':
      return [{joinees: action.joinees}, {candidate: state[1].candidate}];
    case 'GET_CANDIDATE_SUCCESS':
      return [{joinees: state[0].joinees}, {candidate: action.candidate}];
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/Recruitment/recruitReducer.js
 **/